import React from "react";
import ContentLoader from "react-content-loader";

interface IProps {
    className?: string;
}

const CertificateChartSkeleton = (props: IProps) => (
    <ContentLoader viewBox="0 0 500 450" width={500} height={450} {...props}>
        <rect x="0" y="10" rx="0" ry="0" width="500" height="18" />
        <circle cx="200" cy="280" r="140" />
        <rect x="220" y="60" rx="0" ry="0" width="12" height="8" />
        <rect x="240" y="60" rx="0" ry="0" width="240" height="8" />
        <rect x="220" y="80" rx="0" ry="0" width="12" height="8" />
        <rect x="240" y="80" rx="0" ry="0" width="240" height="8" />
        <rect x="220" y="100" rx="0" ry="0" width="12" height="8" />
        <rect x="240" y="100" rx="0" ry="0" width="240" height="8" />
        <rect x="220" y="120" rx="0" ry="0" width="12" height="8" />
        <rect x="240" y="120" rx="0" ry="0" width="240" height="8" />
    </ContentLoader>
);

export default CertificateChartSkeleton;
